import { render, staticRenderFns } from "./InventoryForecast.vue?vue&type=template&id=3ea3118e&scoped=true"
import script from "./InventoryForecast.vue?vue&type=script&lang=js"
export * from "./InventoryForecast.vue?vue&type=script&lang=js"
import style0 from "./InventoryForecast.vue?vue&type=style&index=0&id=3ea3118e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea3118e",
  null
  
)

export default component.exports